export default __webpack_public_path__ + "static/header_cellphone-4dfc3a71fb580d9b91a3d5353035d262.png";